module.exports = __webpack_public_path__ + "img/Mobil1.c12fee41.png";